export interface StorageOptions {
  expire?: number
}

export function setLocalStorage(key: string, value: any, options?: StorageOptions): void {
  const data = {
    value,
    expire: options?.expire ? Date.now() + options.expire * 1000 : null,
  }
  localStorage.setItem(key, JSON.stringify(data))
}

export function getLocalStorage<T = any>(key: string, defaultValue?: T): T | null {
  const item = localStorage.getItem(key)
  if (!item) return defaultValue ?? null

  try {
    const data = JSON.parse(item)
    if (data.expire && Date.now() > data.expire) {
      localStorage.removeItem(key)
      return defaultValue ?? null
    }
    return data.value
  } catch {
    return defaultValue ?? null
  }
}

export function removeLocalStorage(key: string): void {
  localStorage.removeItem(key)
}

export function clearLocalStorage(): void {
  localStorage.clear()
}

export function setSessionStorage(key: string, value: any): void {
  sessionStorage.setItem(key, JSON.stringify(value))
}

export function getSessionStorage<T = any>(key: string, defaultValue?: T): T | null {
  const item = sessionStorage.getItem(key)
  if (!item) return defaultValue ?? null
  try {
    return JSON.parse(item)
  } catch {
    return defaultValue ?? null
  }
}

export function removeSessionStorage(key: string): void {
  sessionStorage.removeItem(key)
}

export function clearSessionStorage(): void {
  sessionStorage.clear()
}

// export function setCookie(key: string, value: any, options?: {
//   days?: number
//   path?: string
//   domain?: string
//   secure?: boolean
//   sameSite?: 'Strict' | 'Lax' | 'None'
// }): void {
//   let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`

//   if (options?.days) {
//     const date = new Date()
//     date.setTime(date.getTime() + options.days * 24 * 60 * 60 * 1000)
//     cookie += `; expires=${date.toUTCString()}`
//   }

//   if (options?.path) {
//     cookie += `; path=${options.path}`
//   }

//   if (options?.domain) {
//     cookie += `; domain=${options.domain}`
//   }

//   if (options?.secure) {
//     cookie += '; secure'
//   }

//   if (options?.sameSite) {
//     cookie += `; SameSite=${options.sameSite}`
//   }

//   document.cookie = cookie
// }

// export function getCookie<T = any>(key: string, defaultValue?: T): T | null {
//   const cookies = document.cookie.split(';')
//   for (const cookie of cookies) {
//     const [k, v] = cookie.split('=')
//     if (k.trim() === encodeURIComponent(key)) {
//       try {
//         return JSON.parse(decodeURIComponent(v))
//       } catch {
//         return defaultValue ?? null
//       }
//     }
//   }
//   return defaultValue ?? null
// }

export function removeCookie(key: string): void {
  document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
}

export function clearCookies(): void {
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const key = cookie.split('=')[0].trim()
    removeCookie(key)
  }
}

export function getLocalStorageSize(): number {
  let total = 0
  for (const key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      total += localStorage[key].length + key.length
    }
  }
  return total
}

export function getSessionStorageSize(): number {
  let total = 0
  for (const key in sessionStorage) {
    if (sessionStorage.hasOwnProperty(key)) {
      total += sessionStorage[key].length + key.length
    }
  }
  return total
}

export function isLocalStorageAvailable(): boolean {
  try {
    const test = '__test__'
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch {
    return false
  }
}

export function isSessionStorageAvailable(): boolean {
  try {
    const test = '__test__'
    sessionStorage.setItem(test, test)
    sessionStorage.removeItem(test)
    return true
  } catch {
    return false
  }
}
